import { render, staticRenderFns } from "./UserRoleSelector.vue?vue&type=template&id=073e176a&scoped=true"
import script from "./UserRoleSelector.vue?vue&type=script&lang=js"
export * from "./UserRoleSelector.vue?vue&type=script&lang=js"
import style0 from "./UserRoleSelector.vue?vue&type=style&index=0&id=073e176a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e176a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('073e176a')) {
      api.createRecord('073e176a', component.options)
    } else {
      api.reload('073e176a', component.options)
    }
    module.hot.accept("./UserRoleSelector.vue?vue&type=template&id=073e176a&scoped=true", function () {
      api.rerender('073e176a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/UserRoleSelector.vue"
export default component.exports